import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BestSales = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to fragrance page with best sales tags
    navigate('/fragrance?tags=Best%20Sales,Top%20Sellers,bestseller', { replace: true });
  }, [navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-white">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#b38f36] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600 font-medium">Loading Best Sales...</p>
      </div>
    </div>
  );
};

export default BestSales;
